import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appPasswordStrength]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordStrengthDirective, multi: true }]
})
export class PasswordStrengthDirective implements Validator {

  //constructor() { }
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) return null; // Skip validation if the field is empty

    const upperCaseCharacters = /[A-Z]+/g;
    if (!upperCaseCharacters.test(value)) {
      return { passwordStrength: 'Password must contain at least one uppercase letter.' };
    }

    const lowerCaseCharacters = /[a-z]+/g;
    if (!lowerCaseCharacters.test(value)) {
      return { passwordStrength: 'Password must contain at least one lowercase letter.' };
    }

    const numberCharacters = /[0-9]+/g;
    if (!numberCharacters.test(value)) {
      return { passwordStrength: 'Password must contain at least one number.' };
    }

    const specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (!specialCharacters.test(value)) {
      return { passwordStrength: 'Password must contain at least one special character.' };
    }

    if (value.length < 8) {
      return { passwordStrength: 'Password must be at least 8 characters long.' };
    }

    if (value.length > 15) {
      return { passwordStrength: 'Password must not exceed 15 characters.' };
    }

    return null; // No errors
  }

}
